import { Checkout } from '@pdqdev/pdq-shared/dist/interfaces';

export interface UnmatchedFeeValue {
  amount: number | null;
  type: Checkout.GroupFeeType;
}

export function emptyUnmatchedFee(): UnmatchedFeeValue {
  return { amount: null, type: Checkout.GroupFeeType.FIXED };
}

// A blank amount is "no extra fee"; the form keeps the type so switching it back on restores it.
export function toUnmatchedFee(value: UnmatchedFeeValue | null | undefined): Checkout.UnmatchedItemFee | null {
  const amount = Number(value?.amount);
  if (value?.amount === null || value?.amount === undefined || `${value.amount}`.trim() === '' || !isFinite(amount)) {
    return null;
  }
  return { amount, type: value.type ?? Checkout.GroupFeeType.FIXED };
}

export function fromUnmatchedFee(fee: Checkout.UnmatchedItemFee | null | undefined): UnmatchedFeeValue {
  return fee ? { amount: fee.amount, type: fee.type ?? Checkout.GroupFeeType.FIXED } : emptyUnmatchedFee();
}
